import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface ReportTicketPayload {
  subject: string;
  description?: string;
  screen?: string;
  /** Captura única (compatibilidad). */
  screenshotBase64?: string;
  /** Varias capturas. */
  screenshots?: string[];
  diagnostics?: string;
}

export interface ReportTicketResult {
  code: string;
  portalUrl: string;
}

@Injectable({ providedIn: 'root' })
export class SupportService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}/support`;

  reportProblem(payload: ReportTicketPayload): Observable<ReportTicketResult> {
    return this.http
      .post<{ data: ReportTicketResult }>(`${this.base}/tickets`, payload)
      .pipe(map((r) => r.data));
  }
}
